
export default function ShareButton( buttonNode ) {

	const href = buttonNode.dataset.href;
	const service = buttonNode.dataset.service;
	
	this.share_action = () => {
		if ( service !== 'mail' ) {
			window.open( href, "_blank");
		} else {
			window.location.href = href;
		}
	}

	buttonNode.addEventListener( 'click', this.share_action, false );
}